import { getAxiosClient } from "../../../services/HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { iNodeInputsOutputs } from "./nodeInputsOutputs-interface";

export const fetchNodeIODetailsByNodeUuid = createAsyncThunk(
  "nodeInputOutput/fetchNodeIODetailsByNodeUuid",
  async (nodeUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(
      `api/eza_app_process_node_io/node-io/${nodeUuid}`
    );
    return response.data as iNodeInputsOutputs[];
  }
);

export const fetchNodeIODetailsByUuid = createAsyncThunk(
  "nodeInputOutput/fetchNodeIODetailsByUuid",
  async (uuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(
      `api/eza_app_process_node_io/uuid/${uuid}`
    );
    return response.data as iNodeInputsOutputs;
  }
);
